module.exports = __webpack_public_path__ + "90cc83fee994e4e18db0867796059ea1.svg";